import { Grid, Collapse, Popover, ClickAwayListener, Paper, MenuItem, IconButton, Box, Typography, Divider, Menu, ListItemIcon, ListItemText } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PhotoSizeSelectActualIcon from '@mui/icons-material/PhotoSizeSelectActual';
import VideocamIcon from '@mui/icons-material/Videocam';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useDispatch, useSelector, useStore } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import Media from "../Media/Media";
import Location from "../Location/Location";
import CommentRating from "../Rating/CommentRating";
import { GetUTCTime } from "../../../Helpers/GetUTCTime";
import { UpdateTemplateDataSpecific } from "../../../Helpers/ApiCall";
import { cleanPayloadOnCommentLevel, cleanPayloadForCommentReorder, insertCommentAfterInDisplayOrder, cloneCommentInputControls, buildRelocatedComment, addCommentToDestination, markCommentDeleted, regenerateCommentPlaceholderIds, waitForInspectionSaveResult, cleanPayloadForCommentRelocation } from "../../../Helpers/HelperFunctions";
import { getTemplateRatingData, resolveCommentRatings } from "../../../Helpers/LineRatingUtils";
import { replacePlaceholdersWithDropdowns, stripLeadingPunctuationFromHtml, stripLeadingPunctuationFromPlainText, normalizeDropdownPlaceholderSyntax } from "./CommentLibraryHelper";
import "../../../../Assets/Styles/Containers/_commentLibraryModal.scss";
import NonNarrativeCL from "./NonNarrativeCL";
import { useNavigate } from "react-router-dom";
import { activateLines, updateInspectionTemplateDataOffline } from "../../../Redux/Actions/CommonActions";
import DeleteCommentDialog from "../../../Common/Alert/DeleteCommentDialog";
import MoveCopyCommentModal from "./MoveCopyCommentModal";
import { isHTCompanyKey } from "../../../Utils/services";
import toast from "react-hot-toast";
import { v4 as uuidv4 } from "uuid";
import { origin } from "../../../Config/Api-constants";
import { MOVE_COPY_TOAST_NAV_SOURCE } from "../../../Config/App-constants";
import axios from "axios";
import { Base64 } from "js-base64";
import { MdOutlineModeEditOutline, MdOutlineFolderCopy } from "react-icons/md";
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LibraryAddOutlinedIcon from "@mui/icons-material/LibraryAddOutlined";
import { MdOutlineUnfoldMore } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";

const CollapsibleComment = ({ html, children, expanded, className, style, fontSize = "14px", maxLines = 15, threshold = 15 }) => {
  const containerRef = useRef(null);
  const [shouldClamp, setShouldClamp] = useState(false);

  useEffect(() => {
    const checkHeight = () => {
      const el = containerRef.current;
      if (el) {
        // Temporarily reset clamp to measure full content height
        const prevClamp = el.style.webkitLineClamp;
        const prevDisplay = el.style.display;
        const prevBoxOrient = el.style.webkitBoxOrient;
        const prevOverflow = el.style.overflow;

        el.style.webkitLineClamp = "unset";
        el.style.display = "block";
        el.style.webkitBoxOrient = "unset";
        el.style.overflow = "visible";

        const height = el.scrollHeight;
        const computedLineHeight = parseFloat(window.getComputedStyle(el).lineHeight);
        const lineHeight = isNaN(computedLineHeight) || computedLineHeight === 0 ? 24 : computedLineHeight;

        // Restore styles
        el.style.webkitLineClamp = prevClamp;
        el.style.display = prevDisplay;
        el.style.webkitBoxOrient = prevBoxOrient;
        el.style.overflow = prevOverflow;

        const lines = Math.round(height / lineHeight);
        if (lines > threshold) {
          setShouldClamp(true);
        } else {
          setShouldClamp(false);
        }
      }
    };

    checkHeight();
    const resizeObserver = new ResizeObserver(() => {
      checkHeight();
    });
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }
    return () => resizeObserver.disconnect();
  }, [html, children, threshold]);

  const clampStyle = !expanded && shouldClamp ? {
    display: "-webkit-box",
    WebkitLineClamp: maxLines,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  } : {
    display: "block",
    WebkitLineClamp: "unset",
    WebkitBoxOrient: "unset",
    overflow: "visible",
  };

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        ...style,
        ...clampStyle,
        width: "100%",
        minWidth: 0,
        wordBreak: "break-word",
        overflowWrap: "break-word",
      }}
    >
      {html !== undefined && html !== null ? (
        <div
          style={{ fontSize, wordBreak: "break-word", overflowWrap: "break-word" }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      ) : (
        <div style={{ fontSize, wordBreak: "break-word", overflowWrap: "break-word" }}>{children}</div>
      )}
    </div>
  );
};

const CommentDetails = (props) => {
  let {
    prompt,
    is_selected,
    recommendation,
    toggle,
    setSelectedImages,
    setSelectedMediaFiles,
    selectedMediaFiles,
    comment_input_controls,
    is_mannual_prompt,
    templateId,
    categoryId,
    isHIP,
    uuid,
    categoryUuid,
    lineUuid,
    setWidth,
    height,
    setHeight,
    commentIndex,
    lineName,
    categoryName,
    comment_dropdowns,
    setLineData, tags, showCommentModal,
    // Reorder/drag support (match narrative props)
    dragHandleRef,
    dragListeners,
    isDragging,
    parentUuid,
    removed_default_rating_id,
    isNewlyDuplicated,
    onCommentDuplicated,
    focusedCommentUuid
  } = props;

  const [commentSelected, setCommentSelected] = useState(false);
  const [showEditCommentModal, setShowEditCommentModal] = useState(false);
  const [inspectionData, setInspectionData] = useState("");
  const [editComment, setEditComment] = useState(false);
  const [disableCommentBtn, setDisableCommentBtn] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [newDropdownList, setNewDropdownList] = useState(null);
  // Returning here from annotating this comment's own photo (PALM-15231) should land
  // on it expanded, not re-collapsed back to its is_selected default.
  const [isExpanded, setIsExpanded] = useState(
    is_selected === 1 || isNewlyDuplicated === true || (focusedCommentUuid !== undefined && uuid === focusedCommentUuid)
  );
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
  const [showMoveCopyModal, setShowMoveCopyModal] = useState(false);
  const [moveCopyMode, setMoveCopyMode] = useState("move");

  const handleOpenOptionsMenu = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setOptionsAnchorEl(event.currentTarget);
  };

  const handleCloseOptionsMenu = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
      event.preventDefault();
    }
    setOptionsAnchorEl(null);
  };

  const handleToggleExpandFromMenu = (event) => {
    handleCloseOptionsMenu(event);
    setIsExpanded((prev) => !prev);
  };

  const handleEditFromMenu = (event) => {
    handleCloseOptionsMenu(event);
    setShowEditCommentModal(true);
    setEditComment(true);
    setDisableCommentBtn(false);
  };

  const handleDuplicateFromMenu = async (event) => {
    handleCloseOptionsMenu(event);
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
    let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item.id === categoryId);
    let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
    if ([templateIndex, categoryIndex, lineIndex].some((idx) => idx === undefined || idx < 0)) return;

    let prevData = JSON.parse(JSON.stringify(inspectionData));
    delete prevData?.report_media_library_files;
    let targetComments = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex]?.comments || [];
    let targetCommentIndex = targetComments.findIndex((item) => item.uuid === uuid);
    if (targetCommentIndex === -1) return;

    const originalComment = targetComments[targetCommentIndex];
    const newCommentUuid = uuidv4();
    const utcNow = await GetUTCTime();

    const duplicatedComment = JSON.parse(JSON.stringify(originalComment));
    duplicatedComment.uuid = newCommentUuid;
    duplicatedComment.created_at = utcNow;
    duplicatedComment.updated_at = utcNow;
    duplicatedComment.is_selected_updated_at = utcNow;
    duplicatedComment.is_deleted = 0;
    duplicatedComment.is_selected = 0;

    duplicatedComment.comment_input_controls = cloneCommentInputControls(duplicatedComment.comment_input_controls, utcNow);
    regenerateCommentPlaceholderIds(duplicatedComment);

    insertCommentAfterInDisplayOrder(targetComments, originalComment, duplicatedComment, utcNow);

    if (typeof setLineData === "function") {
      setLineData(prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex]);
    }
    onCommentDuplicated?.(newCommentUuid);
    // Renumbering touches sibling comments' `order`, so the whole line's comment list is sent
    const filteredObject = cleanPayloadForCommentReorder(prevData, templateIndex, categoryIndex, lineIndex);
    await UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    toast.success("Comment duplicated successfully");
  };

  const cleanHtmlForCopy = (rawHtml, dropdowns) => {
    if (!rawHtml) return "";
    let html = rawHtml;
    html = html.replace(/<h2[^>]*>[\s\S]*?<\/h2>/gi, "").replace(/<button\b[^>]*>.*?<\/button>/gi, "");
    if (Array.isArray(dropdowns) && dropdowns.length > 0) {
      dropdowns.forEach((dd) => {
        const regex = new RegExp(`\\[dropdown\\s+${dd.dropdown_uuid}\\]`, "gi");
        const val = dd.selected_value ? dd.selected_value.replace(/&quot;/g, '"').trim() : "";
        html = html.replace(regex, val);
      });
    }
    html = html.replace(/\[dropdown\s+([a-f0-9-]+)\]/gi, "");
    html = html.replace(/\[textbox\s+id:([a-f0-9-]+)([^\]]*)\]/gi, (match, id, inner) => {
      const vm = inner.match(/value\s*:\s*([^;]+)/i);
      return vm ? vm[1].trim() : "";
    });
    return html.trim();
  };

  const cleanTextForCopy = (rawHtml, dropdowns) => {
    if (!rawHtml) return "";
    let text = cleanHtmlForCopy(rawHtml, dropdowns);
    text = text.replace(/<br\s*\/?>/gi, "\n").replace(/<\/p>/gi, "\n").replace(/<p[^>]*>/gi, "");
    text = text.replace(/<\/?[^>]+(>|$)/g, "");
    const txt = document.createElement("textarea");
    txt.innerHTML = text;
    text = txt.value;
    text = text.replace(/\u00A0/g, " ").replace(/&nbsp;/g, " ");
    return text.split("\n").map((l) => l.trim()).filter(Boolean).join("\n");
  };

  const copyToClipboardWithHtml = async (copiedText, copiedHtml) => {
    try {
      if (
        navigator.clipboard &&
        window.isSecureContext &&
        typeof ClipboardItem !== "undefined" &&
        typeof navigator.clipboard.write === "function"
      ) {
        const htmlBlob = new Blob([copiedHtml || copiedText], { type: "text/html" });
        const textBlob = new Blob([copiedText], { type: "text/plain" });
        const data = new ClipboardItem({
          "text/html": htmlBlob,
          "text/plain": textBlob,
        });
        await navigator.clipboard.write([data]);
      } else if (navigator.clipboard && window.isSecureContext && typeof navigator.clipboard.writeText === "function") {
        await navigator.clipboard.writeText(copiedText);
      } else {
        const listener = (e) => {
          if (copiedHtml) {
            e.clipboardData.setData("text/html", copiedHtml);
          }
          e.clipboardData.setData("text/plain", copiedText);
          e.preventDefault();
        };
        document.addEventListener("copy", listener);
        document.execCommand("copy");
        document.removeEventListener("copy", listener);
      }
      toast.success("Text copied to clipboard");
    } catch (err) {
      console.error("Failed to copy text: ", err);
      try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
          await navigator.clipboard.writeText(copiedText);
          toast.success("Text copied to clipboard");
          return;
        }
      } catch (fallbackErr) {
        console.error("Fallback copy failed: ", fallbackErr);
      }
      toast.error("Failed to copy text to clipboard");
    }
  };

  const handleCopyTextFromMenu = async (event) => {
    handleCloseOptionsMenu(event);

    const cleanTitle = prompt ? cleanTextForCopy(prompt, comment_dropdowns) : "";
    const cleanTitleHtml = prompt ? cleanHtmlForCopy(prompt, comment_dropdowns) : "";
    const cleanDescription = recommendation ? cleanTextForCopy(recommendation, comment_dropdowns) : "";
    const cleanDescriptionHtml = recommendation ? cleanHtmlForCopy(recommendation, comment_dropdowns) : "";

    const textSections = [];
    if (cleanTitle) textSections.push(cleanTitle);
    if (cleanDescription) textSections.push(cleanDescription);
    const copiedText = textSections.join("\n\n");

    const htmlSections = [];
    if (cleanTitleHtml) htmlSections.push(`<p><strong>${cleanTitleHtml}</strong></p>`);
    if (cleanDescriptionHtml) htmlSections.push(cleanDescriptionHtml);
    const copiedHtml = htmlSections.join("");

    await copyToClipboardWithHtml(copiedText, copiedHtml);
  };

  const handleOpenMoveModal = (event) => {
    handleCloseOptionsMenu(event);
    setMoveCopyMode("move");
    setShowMoveCopyModal(true);
  };

  const handleOpenCopyModal = (event) => {
    handleCloseOptionsMenu(event);
    setMoveCopyMode("copy");
    setShowMoveCopyModal(true);
  };

  const navigate = useNavigate();

  const handleMoveOrCopyConfirm = async (destination) => {
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex(
      (item) => item.template_id === templateId
    );
    if (templateIndex === -1 || templateIndex === undefined) return;

    let prevData = JSON.parse(JSON.stringify(inspectionData));
    delete prevData?.report_media_library_files;

    const sourceCatIndex = prevData.inspectiontemplates[templateIndex].categories.findIndex(
      (item) => item.id === categoryId || item.uuid === categoryUuid
    );
    if (sourceCatIndex === -1) return;

    let sourceComments = [];
    let sourceLineIndex = -1;

    if (lineUuid) {
      sourceLineIndex = prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex].lines?.findIndex(
        (line) => line.uuid === lineUuid
      );
      if (sourceLineIndex !== -1 && sourceLineIndex !== undefined) {
        sourceComments = prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex].lines[sourceLineIndex].comments || [];
      }
    } else {
      sourceComments = prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex].comments || [];
    }

    const commentIndex = sourceComments.findIndex((c) => c.uuid === uuid);
    if (commentIndex === -1) return;

    const utcNow = await GetUTCTime();

    const sourceTemplate = prevData.inspectiontemplates[templateIndex];
    const sourceComment = sourceComments[commentIndex];
    const findDestinationTemplate = (dest) =>
      prevData.inspectiontemplates.find((template) => template.template_id === (dest.templateId ?? templateId));
    const relocateTo = (dest) => {
      const destinationTemplate = findDestinationTemplate(dest);
      if (!destinationTemplate) return null;
      const relocatedComment = buildRelocatedComment(sourceComment, utcNow, { sourceTemplate, destinationTemplate });
      const placement = addCommentToDestination(destinationTemplate, dest, relocatedComment, utcNow);
      return placement ? { ...placement, template: destinationTemplate } : null;
    };
    const saveRelocation = async (savingMessage, failureMessage, payload) => {
      const saveResult = waitForInspectionSaveResult(store);
      const savingToastId = toast.loading(savingMessage);
      await UpdateTemplateDataSpecific(dispatch, prevData, payload);
      const { succeeded } = await saveResult;
      toast.dismiss(savingToastId);
      if (succeeded) return true;
      dispatch(updateInspectionTemplateDataOffline(inspectionData));
      if (typeof setLineData === "function" && sourceLineIndex >= 0) {
        setLineData(inspectionData.inspectiontemplates[templateIndex].categories[sourceCatIndex].lines[sourceLineIndex]);
      }
      toast.error(failureMessage);
      return false;
    };

    if (moveCopyMode === "move") {
      const dest = Array.isArray(destination) ? destination[0] : destination;
      if (!dest) return;

      const placement = relocateTo(dest);
      if (!placement) return;

      // Soft delete original comment at source location
      markCommentDeleted(sourceComment, utcNow);

      if (typeof setLineData === "function" && sourceLineIndex >= 0) {
        setLineData(prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex].lines[sourceLineIndex]);
      }
      // Only the source line (original soft-deleted) and the destination line are sent; a comment that sits on
      // the category itself has no source line, so that rare case keeps sending the full data
      const movePayload =
        sourceLineIndex >= 0
          ? cleanPayloadForCommentRelocation(prevData, [
              {
                template: sourceTemplate,
                category: prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex],
                line: prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex].lines[sourceLineIndex],
              },
              placement,
            ])
          : prevData;
      if (!(await saveRelocation("Moving comment...", "Couldn't move the comment. Please try again.", movePayload))) return;

      const { template: targetTemplate, category: targetCat, line: targetLine } = placement;
      const isNarrativeTemplate = targetTemplate?.is_narrative_template === 1;
      const catName = targetCat?.prompt !== null && targetCat?.prompt !== "" ? targetCat.prompt : (targetCat?.name || dest.categoryName || "Untitled");
      const lineName = targetLine?.prompt !== null && targetLine?.prompt !== "" ? targetLine.prompt : (targetLine?.name || dest.lineName || "");
      const destLabel = lineName ? `${catName}/${lineName}` : catName;

      toast.custom(
        (t) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "14px",
              backgroundColor: "#E6F7EC",
              border: "1px solid #A2E6C6",
              borderRadius: "10px",
              padding: "10px 16px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
              color: "#065F46",
              fontSize: "14px",
              fontFamily: '"Source Sans Pro", "Open Sans", sans-serif',
              maxWidth: "90vw",
              opacity: t.visible ? 1 : 0,
              transition: "opacity 200ms ease-in-out",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <CheckCircleIcon style={{ color: "#0B8A46", fontSize: "20px" }} />
              <span>
                Comment moved to{" "}
                <span
                  style={{ fontWeight: 700, textDecoration: "underline", cursor: "pointer", color: "#065F46" }}
                  onClick={() => {
                    toast.dismiss(t.id);
                    if (targetLine) {
                      navigate(
                        `/inspection/${encodeURIComponent(catName)}/${encodeURIComponent(lineName)}`,
                        {
                          state: {
                            line: targetLine,
                            category: targetCat,
                            category_name: catName,
                            template_id: targetTemplate.template_id,
                            category_id: targetCat.id,
                            category_uuid: targetCat.uuid,
                            line_uuid: targetLine.uuid,
                            template_guid: targetTemplate?.template_guid,
                            parent_uuid: targetCat?.parent_uuid,
                            isNarrative: isNarrativeTemplate,
                            clickedFrom: MOVE_COPY_TOAST_NAV_SOURCE,
                            target: "comment",
                          },
                        }
                      );
                      dispatch(activateLines(targetLine.uuid));
                    } else if (targetCat) {
                      navigate(
                        `/inspection/${encodeURIComponent(catName)}`,
                        {
                          state: {
                            category: targetCat,
                            category_name: catName,
                            template_id: targetTemplate.template_id,
                            category_id: targetCat.id,
                            category_uuid: targetCat.uuid,
                            parent_uuid: targetCat?.parent_uuid,
                            isNarrative: isNarrativeTemplate,
                            clickedFrom: MOVE_COPY_TOAST_NAV_SOURCE,
                          },
                        }
                      );
                    }
                  }}
                >
                  {destLabel}
                </span>
              </span>
            </div>
            <CloseIcon
              style={{ fontSize: "18px", color: "#4B5563", cursor: "pointer" }}
              onClick={() => toast.dismiss(t.id)}
            />
          </div>
        ),
        {
          position: "top-center",
          duration: 8000,
        }
      );
    } else {
      // COPY MODE (multi selection)
      const destList = Array.isArray(destination) ? destination : [destination];
      if (destList.length === 0) return;

      const placements = destList.map((dest) => ({ dest, placement: relocateTo(dest) })).filter(({ placement }) => placement);
      if (placements.length === 0) return;

      // The source line is unchanged by a copy, so only the destination lines are sent
      const copyPayload = cleanPayloadForCommentRelocation(prevData, placements.map(({ placement }) => placement));
      if (!(await saveRelocation("Copying comment...", "Couldn't copy the comment. Please try again.", copyPayload))) return;

      let toastId;

      const linkElements = placements.map(({ dest, placement }, idx) => {
        const { template: targetTemplate, category: targetCat, line: targetLine } = placement;
        const isNarrativeTemplate = targetTemplate?.is_narrative_template === 1;
        const catName = targetCat?.prompt !== null && targetCat?.prompt !== "" ? targetCat.prompt : (targetCat?.name || dest.categoryName || "Untitled");
        const lineName = targetLine?.prompt !== null && targetLine?.prompt !== "" ? targetLine.prompt : (targetLine?.name || dest.lineName || "");
        const label = lineName ? `${catName}/${lineName}` : catName;

        return (
          <React.Fragment key={idx}>
            {idx > 0 && ", "}
            <span
              style={{ fontWeight: 700, textDecoration: "underline", cursor: "pointer", color: "#065F46" }}
              onClick={() => {
                if (toastId) toast.dismiss(toastId);
                if (targetLine) {
                  navigate(
                    `/inspection/${encodeURIComponent(catName)}/${encodeURIComponent(lineName)}`,
                    {
                      state: {
                        line: targetLine,
                        category: targetCat,
                        category_name: catName,
                        template_id: targetTemplate.template_id,
                        category_id: targetCat.id,
                        category_uuid: targetCat.uuid,
                        line_uuid: targetLine.uuid,
                        template_guid: targetTemplate?.template_guid,
                        parent_uuid: targetCat?.parent_uuid,
                        isNarrative: isNarrativeTemplate,
                        clickedFrom: MOVE_COPY_TOAST_NAV_SOURCE,
                        target: "comment",
                      },
                    }
                  );
                  dispatch(activateLines(targetLine.uuid));
                } else if (targetCat) {
                  navigate(
                    `/inspection/${encodeURIComponent(catName)}`,
                    {
                      state: {
                        category: targetCat,
                        category_name: catName,
                        template_id: targetTemplate.template_id,
                        category_id: targetCat.id,
                        category_uuid: targetCat.uuid,
                        parent_uuid: targetCat?.parent_uuid,
                        isNarrative: isNarrativeTemplate,
                        clickedFrom: MOVE_COPY_TOAST_NAV_SOURCE,
                      },
                    }
                  );
                }
              }}
            >
              {label}
            </span>
          </React.Fragment>
        );
      });

      toastId = toast.custom(
        (t) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "14px",
              backgroundColor: "#E6F7EC",
              border: "1px solid #A2E6C6",
              borderRadius: "10px",
              padding: "10px 16px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
              color: "#065F46",
              fontSize: "14px",
              fontFamily: '"Source Sans Pro", "Open Sans", sans-serif',
              maxWidth: "90vw",
              opacity: t.visible ? 1 : 0,
              transition: "opacity 200ms ease-in-out",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <CheckCircleIcon style={{ color: "#0B8A46", fontSize: "20px" }} />
              <span>
                Comment copied to {linkElements}
              </span>
            </div>
            <CloseIcon
              style={{ fontSize: "18px", color: "#4B5563", cursor: "pointer" }}
              onClick={() => toast.dismiss(t.id)}
            />
          </div>
        ),
        {
          position: "top-center",
          duration: 8000,
        }
      );
    }
  };

  const handleDeleteFromMenu = (event) => {
    handleCloseOptionsMenu(event);
    setShowDeleteModal(true);
  };

  const deleteNonNarrativeComment = async () => {
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
    let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item.id === categoryId);
    let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
    if ([templateIndex, categoryIndex, lineIndex].some((idx) => idx === undefined || idx < 0)) return;

    let prevData = JSON.parse(JSON.stringify(inspectionData));
    delete prevData?.report_media_library_files;
    let commentIndex = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex]?.comments?.findIndex((item) => item.uuid === uuid);
    if (commentIndex === -1) return;

    markCommentDeleted(prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex], await GetUTCTime());

    if (typeof setLineData === "function") {
      setLineData(prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex]);
    }
    let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, "CommentSelection");
    await UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    setShowDeleteModal(false);
  };
  // redux
  const dispatch = useDispatch();
  const store = useStore();
  const storeData = useSelector((state) => state.CommonReducer);
  // The template's default rating shows here too, unless it was removed from this comment.
  const templateRatingData = getTemplateRatingData(storeData?.inspectionData?.data, templateId);
  const resolvedRatings = resolveCommentRatings({ comment_input_controls, removed_default_rating_id }, templateRatingData);

  // Keep inspection data in sync with store
  useEffect(() => {
    if (storeData.inspectionData) {
      setInspectionData(storeData.inspectionData?.data);
    }
  }, [storeData.inspectionData]);

  // Initialize/refresh selection when switching comments or prop changes
  useEffect(() => {
    setCommentSelected(is_selected);
  }, [uuid, is_selected]);

  const checkComment = async (e, action) => {
    if (action === "outside") {
      setCommentSelected(e.target.checked);
    }
    setCommentSelected(e.target.checked);
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
    let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item.id === categoryId);
    let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
    let prevData = JSON.parse(JSON.stringify(inspectionData));
    delete prevData?.report_media_library_files;
    let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((item) => item.uuid === uuid);
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].is_selected = e.target.checked ? 1 : 0;
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].updated_at = await GetUTCTime();
    let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'CommentSelection');
    UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    // If the comment is checked and not already expanded, expand it
    if (e.target.checked && !isExpanded) {
      setIsExpanded(true);
    }
  };
  let commentDropElements = document.querySelectorAll(".non-ht-comment-cl-detail-dropdown");
  commentDropElements?.forEach((element) => {
    if (element !== null && element !== undefined) {
      const commentUUId = element.getAttribute("comment_uuid");
      const dropdownUUId = element.getAttribute("id");
      element.onclick = (event) => {
        event.stopPropagation();
      };
      element.onchange = async (event) => {
        const selectedValue = event.target.value;
        let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
        let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item?.id === categoryId);
        let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
        let prevData = JSON.parse(JSON.stringify(inspectionData));
        delete prevData?.report_media_library_files;
        let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((item) => item.uuid === commentUUId);
        let dropdownIndex = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex]?.comment_dropdowns?.findIndex(
          (dropdown) => dropdown.dropdown_uuid === dropdownUUId
        );
        if (dropdownIndex !== -1) {
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_dropdowns[dropdownIndex].selected_value = selectedValue;
        } else {
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_dropdowns.push({
            dropdown_uuid: dropdownUUId,
            selected_value: selectedValue,
          });
        }
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].updated_at = await GetUTCTime();
        let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'CommentSelection');
        UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
      };
    }
  });
  let commentInputElements = document.querySelectorAll(".non-ht-comment-input-box");
  commentInputElements?.forEach((element) => {
    if (element !== null && element !== undefined) {
      const commentUUId = element.getAttribute("comment_uuid");
      element.onclick = (event) => {
        event.stopPropagation();
      };
      element.onblur = async (event) => {
        let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
        let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item.id === categoryId);
        let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
        let prevData = JSON.parse(JSON.stringify(inspectionData));
        delete prevData?.report_media_library_files;
        let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((item) => item.uuid == commentUUId);
        const targetId = event.target.id;
        const newValue = event.target.value;
        let commentText = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].recommendation;
        const textboxPattern = new RegExp(`\\[textbox id:${targetId};(.*?)]`, 'g');
        commentText = commentText.replace(textboxPattern, (match, content) => {
          if (/value:.*?;?/.test(content)) {
            return match.replace(/value:[^;\]]*;?/g, `value:${newValue};`);
          } else {
            return match.replace(/\]$/, ` value:${newValue}; ]`);
          }
        });
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].recommendation = commentText;
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].updated_at = await GetUTCTime();
        let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'CommentSelection');
        UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
      }
    }
  });
  const baseUrl = origin();
  let sessionAPIKey = sessionStorage.getItem("CK");
  let sessionSecretKey = sessionStorage.getItem("SK");
  useEffect(() => {
    window.openDropdown = async (inputId, event, dropdowns, commentUUId, listGuid) => {
      event.stopPropagation();
      event.preventDefault();
      const input = document.getElementById(inputId);
      let response;
      if (listGuid && listGuid !== "undefined") {
        try {
          response = await axios.get(`${baseUrl}get-lists?guid=${listGuid}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
              "api-key": `${Base64.decode(sessionAPIKey)}`,
              platform: "web",
              "api-platform": "WRW",
            }
          });
        } catch (e) { console.log(e) }
      }
      if (input) {
        setNewDropdownList(response?.data?.data?.options || dropdowns || []);
        setAnchorEl(input);
      }
    };
  }, [recommendation, comment_dropdowns])

  const handleChangeDropdown = async (event, id) => {
    const selectedValue = event;
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
    let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item?.id === categoryId);
    let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
    let prevData = JSON.parse(JSON.stringify(inspectionData));
    let dropdownIndex;
    let commentID = anchorEl.getAttribute("comment_uuid");
    let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((item) => item.uuid === commentID);
    dropdownIndex = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex]?.comment_dropdowns?.findIndex(
      (dropdown) => dropdown.dropdown_uuid === anchorEl?.id
    );
    if (dropdownIndex !== -1) {
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_dropdowns[dropdownIndex].selected_value = selectedValue;
    }
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].updated_at = await GetUTCTime();
    let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'CommentSelection');
    UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    setAnchorEl(null);
  };

  function decodeHtmlEntities(str) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  }
  const isAnyModalOpen = () => {
    return document.querySelector('.MuiModal-root, .modal, [role="dialog"], [aria-modal="true"]') !== null;
  };

  let { photoCount, videoCount } = (comment_input_controls || []).reduce(
    (acc, item) => {
      const files = Array.isArray(item?.data) ? item.data : [];

      files
        .filter(file => file?.is_deleted !== 1)
        .forEach((file) => {
          if (file?.filetype === "image") {
            acc.photoCount++;
          } else if (file?.filetype === "video") {
            acc.videoCount++;
          }
        });

      return acc;
    },
    { photoCount: 0, videoCount: 0 }
  );

  // While dragging in overlay, always render collpased preview
  const expandedState = isDragging ? false : isExpanded;

  return (
    <>
      {!showEditCommentModal && !showCommentModal ? <Popover open={Boolean(anchorEl) && !isAnyModalOpen()} anchorEl={anchorEl} anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }} sx={{ zIndex: 999999999, }} slotProps={{ paper: { sx: { boxShadow: "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)" } } }} onClose={() => setAnchorEl(null)}>
        <ClickAwayListener onClickAway={() => setAnchorEl(null)} >
          <Paper style={{ width: "184px", maxHeight: "400px", overflowX: "scroll", textOverflow: "ellipsis", }}>
            {newDropdownList?.map((e, index) => (
              <MenuItem key={index} sx={{
                fontSize: "14px",
                padding: "10px 4px 0px 8px",
                fontFamily: "Open Sans",
                letterSpacing: 0,
                overflow: "hidden",         // Ensure overflow is hidden
                whiteSpace: "nowrap",       // Prevent text wrapping
                textOverflow: "ellipsis",   // Apply ellipsis effect
                maxWidth: "220px",
                display: "block"
              }}
                onClick={() => handleChangeDropdown(e, e?.target?.id)}
              >{e}</MenuItem>
            ))}
          </Paper>
        </ClickAwayListener>
      </Popover > : null}
      {showEditCommentModal ? <NonNarrativeCL
        showCommentModal={showEditCommentModal}
        setShowCommentModal={setShowEditCommentModal}
        templateId={templateId}
        categoryId={categoryId}
        lineUuid={lineUuid}
        editComment={editComment}
        setEditComment={setEditComment}
        recommendation={recommendation}
        comment_dropdowns={comment_dropdowns}
        prompt={prompt}
        commentUuid={uuid}
        is_mannual_prompt={is_mannual_prompt}
        disableCommentBtn={disableCommentBtn}
        setDisableCommentBtn={setDisableCommentBtn}
        lineName={lineName}
        categoryName={categoryName}
        comment_input_controls={comment_input_controls}
        removed_default_rating_id={removed_default_rating_id}
        commentIndex={commentIndex}
        categoryUuid={categoryUuid}
        setLineData={setLineData}
        tags={tags}
        parentUuid={parentUuid}
      /> : null}
      <DeleteCommentDialog
        open={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        title={prompt || recommendation ? `Delete comment?` : "Delete?"}
        contentText={"Are you sure you want to delete this comment from the report?"}
        cancelBtnTitle={"Cancel"}
        cancelBtnAction={() => setShowDeleteModal(false)}
        submitBtnTitle={"Delete"}
        submitBtnAction={deleteNonNarrativeComment}
      />
      <MoveCopyCommentModal
        open={showMoveCopyModal}
        handleClose={() => setShowMoveCopyModal(false)}
        mode={moveCopyMode}
        currentCategoryId={categoryId}
        currentCategoryUuid={categoryUuid}
        currentLineUuid={lineUuid}
        templateId={templateId}
        onConfirm={handleMoveOrCopyConfirm}
      />
      <div style={{ padding: "17px 26px 17px 26px" }}>
        <div style={{ backgroundColor: "white", borderRadius: "4px", border: isDragging ? "3px solid rgba(66, 130, 226, 0.25)" : "1px solid #DDD", boxShadow: isDragging ? "0px 4px 18px 0px rgba(0, 0, 0, 0.25)" : "none" }}>
          {/* Header Row */}
          <Grid container alignItems="center" justifyContent="space-between" sx={{ height: "48px", borderBottom: "1px solid #D8D8D8", px: "12px" }}>
            <Grid item>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ cursor: "grab", backgroundColor: "#F4F4F4", borderRadius: "3px", color: "#777777" }}>
                  <span ref={dragHandleRef} {...(dragListeners || {})}>
                    <DragIndicatorIcon fontSize="small" />
                  </span>
                </div>
              </div>
            </Grid>
            <Grid item>
              <Grid container alignItems="center">
                {commentSelected === 1 && (
                  <IconButton size="small" onClick={() => { setShowEditCommentModal(true); setEditComment(true); setDisableCommentBtn(false); }}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                )}
                <IconButton size="small" onClick={(e) => { e.stopPropagation(); setIsExpanded(prev => !prev); }}> {expandedState ? <ExpandLessIcon /> : <ExpandMoreIcon />} </IconButton>
                <IconButton
                  size="small"
                  aria-label="comment options menu"
                  id={`comment_options_btn_${uuid}`}
                  onClick={handleOpenOptionsMenu}
                >
                  <MoreVertIcon fontSize="small" />
                </IconButton>
                <Menu
                  id={`comment_options_menu_${uuid}`}
                  anchorEl={optionsAnchorEl}
                  open={Boolean(optionsAnchorEl)}
                  onClose={handleCloseOptionsMenu}
                  onClick={(e) => e.stopPropagation()}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  sx={{
                    "& .MuiPaper-root": {
                      boxShadow: "rgba(0, 0, 0, 0.01) 0px 4px 4px",
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      border: "1px solid #e0e0e0",
                      padding: "6px 0",
                      width: "240px",
                    },
                  }}
                >
                  <MenuItem onClick={handleToggleExpandFromMenu} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {expandedState ? (
                      <MdOutlineUnfoldMore style={{ fontSize: "20px", color: "#555555" }} />
                    ) : (
                      <MdOutlineUnfoldMore style={{ fontSize: "20px", color: "#555555" }} />
                    )}
                    <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                      {expandedState ? "Collapse comment" : "Expand comment"}
                    </span>
                  </MenuItem>
                  <MenuItem onClick={handleEditFromMenu} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <MdOutlineModeEditOutline style={{ fontSize: "20px", color: "#555555" }} />
                    <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                      Edit comment
                    </span>
                  </MenuItem>
                  <MenuItem onClick={handleDuplicateFromMenu} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <LibraryAddOutlinedIcon style={{ fontSize: "20px", color: "#555555" }} />
                    <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                      Duplicate comment
                    </span>
                  </MenuItem>
                  <MenuItem onClick={handleCopyTextFromMenu} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <ContentCopyIcon  style={{ fontSize: "20px", color: "#555555" }} />
                    <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                      Copy comment text
                    </span>
                  </MenuItem>
                  <MenuItem onClick={handleOpenMoveModal} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <ExitToAppOutlinedIcon style={{ fontSize: "20px", color: "#555555" }} />
                    <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                      Move to...
                    </span>
                  </MenuItem>
                  <MenuItem onClick={handleOpenCopyModal} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <MdOutlineFolderCopy style={{ fontSize: "20px", color: "#555555" }} />
                    <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                      Copy to...
                    </span>
                  </MenuItem>
                  <Divider sx={{ margin: "8px 0" }} />
                  <MenuItem
                    onClick={handleDeleteFromMenu}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      fontWeight: "400 !important",
                      fontSize: "14px !important",
                    }}
                  >
                    <RiDeleteBin6Line style={{ fontSize: "20px", color: "#D53D3D" }} />
                    <span style={{ color: "#D53D3D" }}>Delete comment</span>
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          </Grid>
          {/* Body */}
          <Grid style={{ overflowY: "hidden", padding: "10px 20px 0px 20px" }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
              <FormGroup id={`comment_checkbox_${commentIndex}`}>
                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      sx={{
                        height: "19.5px !important",
                        width: "19.5px !important",
                        "& .MuiSvgIcon-root": { fontSize: "20px !important" },
                      }}
                      checked={!!commentSelected}
                      onChange={(e) => { e.stopPropagation(); checkComment(e, "outside"); }}
                    />
                  }
                />
              </FormGroup>
               {prompt && prompt.trim() !== "" ? (
                <CollapsibleComment
                  expanded={expandedState}
                  className="non_narrative_comment_title"
                  style={{ textDecoration: "none !important" }}
                  id={`comment_title_${commentIndex}`}
                  fontSize="18px"
                  maxLines={3}
                  threshold={3}
                >
                  {prompt?.replace(/\[dropdown\s+([a-f0-9-]+)\]/gi, (m, uuid) => {
                          const dropdown = comment_dropdowns?.find(item => item.dropdown_uuid === uuid);
                          return decodeHtmlEntities(dropdown?.selected_value?.trim() || "");
                        }).replace(/\[textbox\s+id:([a-f0-9-]+)([^\]]*)\]/gi,
                          (match, id, inner) => {
                            const vm = inner.match(/value\s*:\s*([^;]+)/i); // first value before first semicolon
                            const value = vm ? vm[1].trim() : "";
                            return value ? decodeHtmlEntities(value) + " " : "";
                          }).replace(/<button\b[^>]*>.*?<\/button>/gi, "")
                    .replace(/<\/?[^>]+(>|$)/g, "")
                    .trim()}
                </CollapsibleComment>
              ) : (
                <CollapsibleComment
                  expanded={expandedState}
                  className="non_ht_comment_dropdown comment_description"
                  style={{ display: "inline-block", paddingLeft: 0 }}
                  fontSize="14px"
                  html={replacePlaceholdersWithDropdowns(
                    is_mannual_prompt !== undefined && is_mannual_prompt === 0 && !recommendation
                      ? ""
                      : prompt === null || prompt === "" || prompt === undefined
                        ? recommendation
                          ?.replace(/<h2[^>]*>[\s\S]*?<\/h2>/gi, "")        // remove <h2>...</h2>
                          ?.replace(/&nbsp;/g, " ")                         // replace &nbsp; with space
                        : recommendation !== null && recommendation !== undefined && recommendation !== ""
                          ? recommendation
                            ?.replace(/<h2[^>]*>[\s\S]*?<\/h2>/gi, "")
                            ?.replace(/&nbsp;/g, " ")
                          : ""
                    ,
                    comment_dropdowns,
                    "non-ht-comment",
                    uuid
                  )}
                />
              )}
            </div>
            {prompt && prompt.trim() !== "" && (
              <Grid className="comment_detail_title">
                <CollapsibleComment
                  expanded={expandedState}
                  className="non_ht_comment_dropdown comment_description"
                  fontSize="14px"
                  html={replacePlaceholdersWithDropdowns(
                    is_mannual_prompt !== undefined && is_mannual_prompt === 0 && !recommendation
                      ? ""
                      : prompt === null || prompt === "" || prompt === undefined
                        ? recommendation
                          ?.replace(/<h2[^>]*>[\s\S]*?<\/h2>/gi, "")        // remove <h2>...</h2>
                          ?.replace(/&nbsp;/g, " ")                         // replace &nbsp; with space
                        : recommendation !== null && recommendation !== undefined && recommendation !== ""
                          ? recommendation
                            ?.replace(/<h2[^>]*>[\s\S]*?<\/h2>/gi, "")
                            ?.replace(/&nbsp;/g, " ")
                          : ""
                    ,
                    comment_dropdowns,
                    "non-ht-comment",
                    uuid
                  )}
                />
              </Grid>
            )}
          </Grid>
          {!expandedState && (
            <Grid item xs={12} container sx={{ ml: 5, mb: 2, pr: 5 }}>
              <Box display="flex" alignItems="center">
                <Box>
                  <div className="cl_summary_rating_section">
                    {resolvedRatings?.length > 0 ? (
                      resolvedRatings.map((rating) => (
                        <div className="cl_summary_rating_square_container" key={rating.Id}>
                          <div
                            className="rating_square"
                            style={{ background: `${rating.Color}`, padding: "4px" }}
                          ></div>
                          <div className="cl_rating_name_text">{rating.Name}</div>
                        </div>
                      ))
                    ) : null}
                    {resolvedRatings?.length > 0 ? <Divider orientation="vertical" flexItem sx={{ mx: 0.5, borderColor: "#979797 !important" }} /> : null}
                    <Box display="flex" alignItems="center" sx={{ gap: "2px" }}>
                      <PhotoSizeSelectActualIcon sx={{ fontSize: "17px" }} />
                      <Typography className="photo_text">{photoCount} Photos</Typography>
                      <VideocamIcon sx={{ fontSize: "19px" }} />
                      <Typography className="photo_text">{videoCount} Videos</Typography>
                    </Box>
                  </div>
                </Box>
              </Box>
            </Grid>
          )}
          <Collapse in={expandedState}>
            {/* ==========Rating===================== */}
            <Grid container sx={{ mt: "17px", px: "16px" }}>
              <CommentRating
                data={resolvedRatings}
                title="Rating"
                action="comment"
                templateId={templateId}
                categoryId={categoryId}
                lineUuid={lineUuid}
                commentUuid={uuid}
                commentIndex={commentIndex}
                component={"comment"}
              />
            </Grid>

            {/* ==========Location===================== */}
            {isHIP !== 1 ? <Grid container sx={{ mt: "32px", px: "16px" }}>
              <Location
                data={comment_input_controls?.find((data) => data.type === "Location")}
                title="Location"
                action="comment"
                templateId={templateId}
                categoryId={categoryId}
                lineUuid={lineUuid}
                type="comment"
                commentUuid={uuid}
                commentIndex={commentIndex}
              />
            </Grid> : null}
            {/* ==========media===================== */}
            <Grid container sx={{ mt: "32px", px: "16px", pb: "16px" }}>
              <Media
                data={comment_input_controls?.find((data) => data.type === "Media")}
                title="Add Media"
                action="comment"
                toggle={toggle}
                templateId={templateId}
                categoryId={categoryId}
                categoryUuid={categoryUuid}
                lineUuid={lineUuid}
                commentUuid={uuid}
                setSelectedImages={setSelectedImages}
                selectedMediaFiles={selectedMediaFiles}
                setSelectedMediaFiles={setSelectedMediaFiles}
                width={setWidth}
                setWidth={setWidth}
                height={height}
                setHeight={setHeight}
                commentIndex={commentIndex}
                component={"nonNarrativeComment"}
              />
            </Grid>
          </Collapse>
        </div>
      </div>
    </>
  );
};

export default CommentDetails;